import { render, staticRenderFns } from "./TriggerEditor.vue?vue&type=template&id=312d7822&"
import script from "./TriggerEditor.vue?vue&type=script&lang=ts&"
export * from "./TriggerEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports